import {DataObjectId, Hub, TasksListId} from 'yougile-model'
import {ColConfig, RowConfig } from '@components/common/sandbox/list-view/types'
import {SubtaskUtil} from '@extensions/subtask-util'
import {Task} from '@extensions/task'

export interface ListData {
  columns: ColConfig<Hub>[],
  rows: RowConfig<Hub>[]
}

export const parseTaskToRows = (
  tasksListId: TasksListId,
  tasks: DataObjectId[],
  parents: DataObjectId[]
): RowConfig<Hub>[] => {
  return tasks.reduce<RowConfig<Hub>[]>((acc, taskId) => {
    const task = Task.getById(taskId)
    const taskIsDone = task && Task.isDone(task)

    if (!task) {
      return acc
    }

    const subtasks = SubtaskUtil.getSubtasksFromListAsHub(
      SubtaskUtil.getSubtaskList(task)
    )
      .map(subtask => subtask.id)
      .filter(subtaskId => !parents.includes(subtaskId))

    acc.push({
      data: task,
      transferData: {
        type: 'task',
        id: taskId,
        listId: tasksListId
      },
      draggable: !taskIsDone,
      draggableOut: !taskIsDone,
      children: subtasks.length
        ? parseTaskToRows(tasksListId, subtasks, [...parents, task.id])
        : []
    })

    return acc
  }, [])
}